import { UI_ROOT } from "../../../app";
//const UI_ROOT = "own";
import  RootViewOwn from "./view/root.own";
import  RootViewMui from "./view/root.mui";

export const RootView = () => {
    switch (UI_ROOT) {
        case "own":
            return <RootViewOwn/>
    
        default:
            return  <RootViewMui />
    }
}